import { getLongCodeByToken } from "@/api/login";

/**
 * @description 将date转为字符串：yyyy-MM-dd格式
 * @author fzg
 */
export const dateToString = (date) => {
    var Y = date.getFullYear();
    var M = date.getMonth() + 1;
    var D = date.getDate();
    return Y + '-' + (M < 10 ? ('0' + M) : M) + '-' + (D < 10 ? ('0' + D) : D);
}

//加密、解密算法封装：
export function Base64() {
    // private property
    let _keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    // 公共编码方法
    this.encode = function (input) {
        var output = "";
        var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
        var i = 0;
        input = _utf8_encode(input);
        while (i < input.length) {
            chr1 = input.charCodeAt(i++);
            chr2 = input.charCodeAt(i++);
            chr3 = input.charCodeAt(i++);
            enc1 = chr1 >> 2;
            enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
            enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
            enc4 = chr3 & 63;
            if (isNaN(chr2)) {
                enc3 = enc4 = 64;
            } else if (isNaN(chr3)) {
                enc4 = 64;
            }
            output = output +
                _keyStr.charAt(enc1) + _keyStr.charAt(enc2) +
                _keyStr.charAt(enc3) + _keyStr.charAt(enc4);
        }
        return output;
    }

    // 公共解码方法
    this.decode = function (input) {
        var output = "";
        var chr1, chr2, chr3;
        var enc1, enc2, enc3, enc4;
        var i = 0;
        input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
        while (i < input.length) {
            enc1 = _keyStr.indexOf(input.charAt(i++));
            enc2 = _keyStr.indexOf(input.charAt(i++));
            enc3 = _keyStr.indexOf(input.charAt(i++));
            enc4 = _keyStr.indexOf(input.charAt(i++));
            chr1 = (enc1 << 2) | (enc2 >> 4);
            chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
            chr3 = ((enc3 & 3) << 6) | enc4;
            output = output + String.fromCharCode(chr1);
            if (enc3 != 64) {
                output = output + String.fromCharCode(chr2);
            }
            if (enc4 != 64) {
                output = output + String.fromCharCode(chr3);
            }
        }
        output = _utf8_decode(output);
        return output;
    }

    // UTF-8编码的私有方法
    const _utf8_encode = function (string) {
        string = string.replace(/\r\n/g, "\n");
        var utftext = "";
        for (var n = 0; n < string.length; n++) {
            var c = string.charCodeAt(n);
            if (c < 128) {
                utftext += String.fromCharCode(c);
            } else if ((c > 127) && (c < 2048)) {
                utftext += String.fromCharCode((c >> 6) | 192);
                utftext += String.fromCharCode((c & 63) | 128);
            } else {
                utftext += String.fromCharCode((c >> 12) | 224);
                utftext += String.fromCharCode(((c >> 6) & 63) | 128);
                utftext += String.fromCharCode((c & 63) | 128);
            }
        }
        return utftext;
    }

    // UTF-8解码的私有方法
    const _utf8_decode = function (utftext) {
        var string = "";
        var i = 0;
        var c = 0, c1 = 0, c2 = 0, c3;
        while (i < utftext.length) {
            c = utftext.charCodeAt(i);
            if (c < 128) {
                string += String.fromCharCode(c);
                i++;
            } else if ((c > 191) && (c < 224)) {
                c2 = utftext.charCodeAt(i + 1);
                string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
                i += 2;
            } else {
                c2 = utftext.charCodeAt(i + 1);
                c3 = utftext.charCodeAt(i + 2);
                string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
                i += 3;
            }
        }
        return string;
    }
}

/**
 * 去除字符串中的空格
 * @param value
 * @returns {*}
 */
export const removeAllSpacesFormatter = function (value) {
    return value.replace(/\s/g, '');
}

/**
 * 格式化数字，每三位加逗号（千分位格式化）
 * @param {number|string} num - 要格式化的数字
 * @returns {string} 格式化后的字符串
 */
export const formatNumberWithCommas = function (num) {
    if (num === null || num === undefined || num === '') {
        return '0';
    }
    const numStr = String(num);
    return numStr.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

/**
 * 转换用户列表格式
 * @param data
 * @param onlyParent
 */
export function transformParentChildData(data, onlyParent = false) {
    const result = [];

    data.forEach(parent => {
        const children = parent.studentUsers || [];
        const partResult = [];

        if (children.length > 0 && !onlyParent) {
            children.forEach(child => {
                // 修改后的家长
                const updatedParent = {
                    selectId: parent.userId + (child.userId || ""),
                    ...parent,
                    userName: child.userName,
                    nickName: `${child.nickName}`,
                    childId: child.userId,
                    studentUsers: null,
                    grade: child.grade || null
                };

                partResult.push(updatedParent);
            });
        } else {
            const updatedParent = {
                selectId: parent.userId,
                ...parent,
                childId: null,
                studentUsers: null,
                grade: null
            };
            partResult.push(updatedParent);
        }

        result.push(...partResult);
    });
    console.log("transformParentChildData", result);

    return result;
}

// 使用微信明文url scheme 打开小程序
export async function openMiniApp(options) {
    let {
        appid,           // 必填：小程序的appid
        path,            // 必填：小程序页面路径，不包含query参数
        query = {},      // 选填：查询参数对象，最大512字符
        envVersion  // 选填：小程序版本，默认正式版
    } = options;

    // 增加默认值
    if (!envVersion) {
        envVersion = 'release'; // 默认正式版
    }

    if (!appid) {
        appid = 'wxc9df72984089ce31'; // 默认小程序appid
    }

    if (!path) {
        console.error('openMiniApp: path 是必填参数');
        return '';
    }

    // 验证envVersion参数
    const validEnvVersions = ['release', 'trial', 'develop'];
    let finalEnvVersion = envVersion;
    if (!validEnvVersions.includes(finalEnvVersion)) {
        console.warn('openMiniApp: envVersion 参数无效，使用默认值 release');
        finalEnvVersion = 'release';
    }

    // 处理path参数：确保格式为 pages/guide/guide
    let cleanPath = path;
    // 移除前导斜杠
    if (cleanPath.startsWith('/')) {
        cleanPath = cleanPath.substring(1);
    }
    // 移除.html后缀
    if (cleanPath.endsWith('.html')) {
        cleanPath = cleanPath.replace(/\.html$/, '');
    }
    // 移除尾随斜杠
    if (cleanPath.endsWith('/')) {
        cleanPath = cleanPath.slice(0, -1);
    }
    // 确保路径不为空
    if (!cleanPath) {
        console.error('openMiniApp: 处理后的path为空');
        return '';
    }

    // 构建基础URL
    let url = `weixin://dl/business/?appid=${appid}&path=${cleanPath}`;

    // 先获取code，确保异步操作完成后再构建URL
    try {
        const res = await getLongCodeByToken({});
        if (res.code == 200) {
            query.code = res.msg;
        } else {
            console.error('openMiniApp: 获取code失败');
        }
    } catch (error) {
        console.error('openMiniApp: 获取code出错:', error);
    }

    // 处理query参数：将对象转换为查询字符串，然后进行双重编码
    if (query && typeof query === 'object' && Object.keys(query).length > 0) {
        // 过滤掉null、undefined和空字符串的值
        const validEntries = Object.entries(query)
            .filter(([key, value]) => key != null && value != null && value !== '')
            .map(([key, value]) => `${encodeURIComponent(String(key))}=${encodeURIComponent(String(value))}`);

        if (validEntries.length > 0) {
            const queryString = validEntries.join('&');

            if (queryString.length > 512) {
                console.warn('openMiniApp: query 参数编码后超过512字符限制');
            }
            // 将整个查询字符串再次编码作为query参数值
            const encodedQuery = encodeURIComponent(queryString);
            url += `&query=${encodedQuery}`;
        }
    }

    // 添加环境版本参数
    url += `&env_version=${finalEnvVersion}`;

    // 直接进行跳转
    try {
        console.log('开始跳转小程序:', url);
        window.location.href = url;
        return true;
    } catch (error) {
        console.error('跳转小程序失败:', error);
        return false;
    }
}

/**
 * 通过明文url scheme 直接跳转到小程序
 * @param {Object} options - 跳转参数
 * @param {string} options.appid - 小程序appid
 * @param {string} options.path - 页面路径，如 'pages/guide/guide'
 * @param {Object} options.query - 查询参数对象，如 {id: 123, type: 'test'}
 * @param {string} options.envVersion - 环境版本
 */
export async function navigateToMiniApp(options) {
    try {
        const result = await openMiniApp(options);
        if (!result) {
            console.error('navigateToMiniApp: 跳转失败');
        }
    } catch (error) {
        console.error('跳转小程序失败:', error);
    }
}

/**
 * 跳转小程序 会员支付
 * 'release', 'trial', 'develop'
 */
export async function openMiniAppPayVip(query = {}) {
    const options = {
        appid: 'wxc9df72984089ce31',
        path: 'pages/pay/index',
        envVersion: 'release',
        query: query
    };

    try {
        const result = await openMiniApp(options);
        if (!result) {
            console.error('openMiniAppPayVip: 跳转失败');
        }
    } catch (error) {
        console.error('跳转小程序失败:', error);
    }
}

/**
 * 跳转小程序 商品购买
 * 'release', 'trial', 'develop'
 */
export async function openMiniAppPayProduct(id) {
    const options = {
        appid: 'wxc9df72984089ce31',
        path: 'pages/pay/goods/goods',
        query: {
            id: id
        },
        envVersion: 'release'
    };

    try {
        const result = await openMiniApp(options);
        if (!result) {
            console.error('openMiniAppPayProduct: 跳转失败');
        }
    } catch (error) {
        console.error('跳转小程序失败:', error);
    }
}